<div role="group" class="mat-mdc-form-field-input-control duration-input-container" [attr.aria-label]="groupLabel || null"
     [formGroup]="parts" (focusin)="onFocusIn($event)"
     (focusout)="onFocusOut($event)">
    <input type="tel" class="duration-input-element mat-mdc-input-element mdc-text-field__input"
           formControlName="years"
           maxLength="2"
           [id]="testId + '-years'"
           aria-label="Years" autocomplete="off" numbersOnly
           (input)="_handleInput(parts.controls.years)"
           [attr.data-test-id]="testId + '.years-input'"
           #years>
    <span class="input-prefix" [attr.data-test-id]="testId + '.years-label'">Years</span>
    <!--	<span class="example-tel-input-spacer"></span>-->
    <input type="tel" class="duration-input-element mat-mdc-input-element mdc-text-field__input"
           formControlName="months"
           maxLength="2"
           [id]="testId + '-months'"
           aria-label="Months" autocomplete="off" numbersOnly
           (input)="_handleInput(parts.controls.months)"
           (keyup.backspace)="autoFocusPrev(parts.controls.months, years)"
           [attr.data-test-id]="testId + '.months-input'"
           #months>
    <span class="input-prefix" [attr.data-test-id]="testId + '.months-label'">Months</span>
</div>
